/**
 * Layers AST slice. Carries the component tree extracted from the screen
 * sources by the on-open AST sync — the single read path for the Layers
 * panel and any inspector surface that needs "what's in the app right now".
 */
import isEqual from 'lodash/isEqual';

export type LayerNode = {
  id: string;
  type: string;
  name?: string;
  /** File path the layer was found in. */
  source: string;
  children: LayerNode[];
};

export interface LayersAstState {
  /** Parsed layer tree per source path. `null` until first AST sync. */
  byPath: Record<string, LayerNode[]> | null;
}

const layersAstInitial: LayersAstState = { byPath: null };

export type LayersAstAction =
  | { type: 'LAYERS_AST_SET'; byPath: Record<string, LayerNode[]> }
  | { type: 'LAYERS_AST_CLEAR' };

export function layersAst(state: LayersAstState = layersAstInitial, action: any): LayersAstState {
  switch ((action as LayersAstAction).type) {
    case 'LAYERS_AST_SET': {
      const a = action as Extract<LayersAstAction, { type: 'LAYERS_AST_SET' }>;
      if (state.byPath && isEqual(state.byPath, a.byPath)) return state;
      return { byPath: a.byPath };
    }
    case 'LAYERS_AST_CLEAR':
      return layersAstInitial;
    default:
      return state;
  }
}

export const setLayersAst = (byPath: Record<string, LayerNode[]>): LayersAstAction => ({
  type: 'LAYERS_AST_SET',
  byPath,
});
